import { Button, Checkbox, Col, Card, Form, Input, Row, Collapse, Select, notification, Modal, Table, Space, theme, Steps, Tabs, List, Descriptions, Tooltip, Pagination, DatePicker } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined, SettingOutlined, ArrowLeftOutlined, UserOutlined, VideoCameraOutlined, ReloadOutlined, EditOutlined, ExportOutlined } from "@ant-design/icons";
import { Fragment, useEffect, useState } from "react";
import * as animationData from "../serviceanim.json";
import Lottie from "react-lottie";
import { validateEmail } from "../utils/methods";
import axios from "axios";
import { API_ENDPOINT } from "../api/endPoint";
import { useNavigate } from "react-router-dom";
import CreateServiceRequest from "./CreateServiceRequest";
import Address from "./Address";
import moment from "moment";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const SRList = (props) => {
  const { useToken } = theme;
  const { token } = useToken();
  const [api, contextHolder] = notification.useNotification();
  const [isCreating, setIsCreating] = useState(false);
  const navigate = useNavigate();
  const [srs, setSrs] = useState([]);
  const [bsrs, setBackupSRS] = useState([]);
  const [isGettingStatus, setIsGettingStatus] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isGettingStatusIndi, setIsGettingStatusIndi] = useState(false);
  const [searchText, setSearchText] = useState("");
  const { Panel } = Collapse;
  const { Search } = Input;
  const { onSREdit } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [totalItems, setTotalItems] = useState(1);
  const [filterValue, setFilterValue] = useState("all");
  const [startDate, setStartDate] = useState(dayjs(moment().subtract(2, "month").startOf("month").toDate()));
  const [endDate, setEndDate] = useState(dayjs(moment().endOf("month").toDate()));
  const [isExporting, setIsExporting] = useState(false);

  const { RangePicker } = DatePicker;

  const columns = [
    {
      title: "eID",
      dataIndex: "eid",
      key: "eid",
    },
    {
      title: "Problem",
      dataIndex: "problem",
      key: "problem",
    },
    {
      title: "Description",
      dataIndex: "desc",
      key: "desc",
    },
    {
      title: "Ticket No",
      dataIndex: "ticketNo",
      key: "ticketNo",
    },
  ];

  if (isEnabled) {
    columns.splice(3, 0, {
      title: "Issue",
      dataIndex: "issue",
      key: "issue",
    });
    columns.push(
      {
        title: "Service Testing",
        dataIndex: "serviceTestingRequired",
        key: "serviceTestingRequired",
        render: (_, { serviceTestingRequired }) => <Space size="middle">{serviceTestingRequired ? "YES" : "NO"}</Space>,
      },
      {
        title: "Advance Replacement",
        dataIndex: "advanceReplacement",
        key: "advanceReplacement",
        render: (_, { advanceReplacement }) => <Space size="middle">{advanceReplacement ? "YES" : "NO"}</Space>,
      }
    );
  }

  const getStatus = async (srn, item) => {
    try {
      setIsGettingStatus(true);
      let response = await axios.get(API_ENDPOINT + "/status/" + srn);
      if (response.data.success && response.data.status && response.data.status.statuses && response.data.status.statuses.length > 0) {
        item["status"] = response.data.status;
      }
      setIsGettingStatus(false);
    } catch (err) {
      setIsGettingStatus(false);
    }
  };

  const getUserDetails = async () => {
    try {
      let response = await axios.get(API_ENDPOINT + "/users/detail");
      if (response.data.user) {
        if (response.data.user.isCreatingEnabled) {
          setIsEnabled(true);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const onPageChange = async (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
    await getServiceRequests(page, pageSize);
  };

  const getServiceRequests = async (page, pageSize) => {
    try {
      let response = await axios.get(API_ENDPOINT + "/list/by?page=" + page + "&limit=" + pageSize + "&start=" + startDate + "&end=" + endDate + "&filter=" + filterValue);
      console.log(response.data);
      if (response.data.list) {
        response.data.list.forEach((item) => {
          item["key"] = item["_id"];
          if (item.orderId && item.dcId) {
            item["statusLean"] = "DC & ORDER";
          } else if (item.orderId) {
            item["statusLean"] = "ORDER";
          } else if (item.dcId) {
            item["statusLean"] = "DC";
          } else if (item.isAdvanceReplaced) {
            item["statusLean"] = "ADVANCE-REPLACED";
          } else if (item.isDeviceReceived) {
            item["statusLean"] = "DEVICE-RECEIVED";
          } else {
            item["statusLean"] = "Awaiting Device Arrival";
          }
        });
        setSrs(response.data.list);
        setBackupSRS(response.data.list);
        setTotalItems(response.data.totalItems);
      }
    } catch (err) {}
  };

  const getServiceRequestsSingle = async () => {
    setCurrentPage(1);
    setPageSize(10);
    try {
      if (searchText == "") {
        await getServiceRequests(currentPage, pageSize);
        return;
      }
      let response = await axios.get(API_ENDPOINT + "/list/by/single/" + searchText);
      console.log(response.data);
      if (response.data.list) {
        response.data.list.forEach((item) => {
          item["key"] = item["_id"];
          if (item.orderId && item.dcId) {
            item["statusLean"] = "DC & ORDER";
          } else if (item.orderId) {
            item["statusLean"] = "ORDER";
          } else if (item.dcId) {
            item["statusLean"] = "DC";
          } else if (item.isAdvanceReplaced) {
            item["statusLean"] = "ADVANCE-REPLACED";
          } else if (item.isDeviceReceived) {
            item["statusLean"] = "DEVICE-RECEIVED";
          } else {
            item["statusLean"] = "Awaiting Device Arrival";
          }
        });
        setSrs(response.data.list);
        setBackupSRS(response.data.list);
      }
    } catch (err) {}
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  useEffect(() => {
    getServiceRequests(currentPage, pageSize);
  }, [startDate, endDate, filterValue]);

  useEffect(() => {
    handleChange(filterValue);
  }, [bsrs]);

  const handleChange = (value) => {
    setFilterValue(value);
  };

  const exportCurrentView = () => {
    // data must be an array of objects
    setIsExporting(true);
    let data = [];
    for (const sr of srs) {
      if (sr.devices) {
        for (const device of sr.devices) {
          data.push({
            SRN: sr.srn,
            Date: moment(sr.createdAt).format("lll"),
            MONTH: moment(sr.createdAt).format("MMMM"),
            YEAR: moment(sr.createdAt).format("YYYY"),
            NAME: sr.name,
            EMAIL: sr.email,
            PHONE: sr.phone,
            EID: device.key,
            PROBLEM: device.problem.trim(),
            DESCRIPTION: device.desc ?? "",
            STATUS: sr.status,
            State: sr.bAddress?.state ?? "",
            "Testing Required": device.serviceTestingRequired == true ? "YES" : "NO",
            "Advance Replacement": sr.isAdvanceReplaced == true ? "YES" : "NO",
          });
        }
      }
    }

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Service Requests");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    let fileName = "service_requests_export_" + new Date().getTime() + ".xlsx";
    saveAs(blob, fileName);
    setTimeout(() => {
      setIsExporting(false);
    }, 1000);
  };

  return (
    <Fragment>
      <Col span={24}>
        <Search
          allowClear
          onChange={(event) => {
            setSearchText(event.target.value);
            if (event.target.value == "") {
              getServiceRequests(currentPage, pageSize);
            }
          }}
          placeholder="Type SRN / eID / Billing Address Name/Customer Information & Press Enter"
          loading={isGettingStatusIndi}
          enterButton
          style={{ marginBottom: 20 }}
          onPressEnter={async () => {
            await getServiceRequestsSingle();
          }}
          onSearch={async () => {
            await getServiceRequestsSingle();
          }}
        />
        <Row
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          {/* LEFT SIDE: Pagination */}
          <Pagination current={currentPage} total={totalItems} pageSize={pageSize} onChange={onPageChange} />

          {/* RIGHT SIDE: grouped items */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              style={{ marginRight: 20 }}
              icon={<ExportOutlined />}
              loading={isExporting}
              onClick={() => {
                exportCurrentView();
              }}
            >
              Export
            </Button>
            <RangePicker
              format="DD MMM, YYYY"
              style={{ marginRight: 10 }}
              defaultValue={[startDate, endDate]}
              onChange={(values) => {
                setStartDate(values?.[0]);
                setEndDate(values?.[1]);
              }}
            />

            <strong style={{ marginRight: 10 }}>Filter :</strong>

            <Select
              defaultValue="all"
              style={{ width: 180 }}
              onChange={handleChange}
              options={[
                { value: "all", label: "All" },
                { value: "dc", label: "Delivery Challan" },
                { value: "order", label: "Service Order" },
                { value: "both", label: "Service Order & DC" },
                { value: "ar", label: "Advance Replaced" },
                { value: "ada", label: "Awaiting Device Arrival" },
                { value: "tr", label: "Testing Required" },
              ]}
            />
          </div>
        </Row>
        <List
          header={<div>All Service Requests ({srs.length}) :</div>}
          bordered
          dataSource={srs}
          renderItem={(item) => (
            <List.Item>
              <Collapse style={{ width: "100%" }}>
                <Panel header={`SRN : ${item.srn}`} extra={`Status : ${item.statusLean}`}>
                  <Col span={24}>
                    {isEnabled && (
                      <Row style={{ margin: 20 }} justify="end">
                        <Tooltip title="Edit Service Request">
                          <Button
                            type="primary"
                            shape="circle"
                            icon={<EditOutlined />}
                            onClick={() => {
                              onSREdit(item);
                            }}
                          />
                        </Tooltip>
                      </Row>
                    )}
                    <Collapse>
                      <Panel header="Devices" key="1">
                        <Table dataSource={item.devices} columns={columns} style={{ overflow: "scroll" }} />
                      </Panel>
                    </Collapse>
                    {item.custInfo != undefined && (
                      <Collapse style={{ marginTop: 10 }}>
                        <Panel header="Customer Information" key="1">
                          <Descriptions title="User Info">
                            {item.custInfo.name && <Descriptions.Item label="Name">{item.custInfo.name}</Descriptions.Item>}
                            {item.custInfo.email && <Descriptions.Item label="Email">{item.custInfo.email}</Descriptions.Item>}
                            {item.custInfo.phone && <Descriptions.Item label="Mobile">{item.custInfo.phone}</Descriptions.Item>}
                            {item.custInfo.comment && <Descriptions.Item label="Additional Information">{item.custInfo.comment}</Descriptions.Item>}
                          </Descriptions>
                        </Panel>
                      </Collapse>
                    )}
                    <Row gutter={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                      <Col span={{ sm: 24, md: 12, xs: 24 }} style={{ padding: 10 }} flex={1}>
                        <Collapse>
                          <Panel header="Billing Address" key="1">
                            <Address type="billing" address={item.bAddress} onAddressChange={() => {}} />
                          </Panel>
                        </Collapse>
                      </Col>
                      <Col span={{ sm: 24, md: 12 }} style={{ padding: 10 }} flex={1}>
                        <Collapse>
                          <Panel header="Shipping Address" key="2">
                            <Address type="shipping" address={item.sAddress} onAddressChange={() => {}} />
                          </Panel>
                        </Collapse>
                      </Col>
                    </Row>
                    <Collapse>
                      <Panel
                        header="Status"
                        extra={
                          <Button
                            type="primary"
                            icon={<ReloadOutlined />}
                            loading={isGettingStatus}
                            onClick={() => {
                              getStatus(item.srn, item);
                            }}
                          />
                        }
                      >
                        {item.status && item.status.statuses && item.status.statuses.length > 0 && (
                          <Card title={`Status for Service Request : ${item.srn.toUpperCase()}`} style={{ marginTop: 20, backgroundColor: "transparent" }}>
                            <Steps items={item.status.statuses} status="finish" current={item.status.current} direction="vertical" />
                          </Card>
                        )}
                      </Panel>
                    </Collapse>
                    <div style={{ margin: 10 }}>
                      <Row>
                        <b style={{ marginRight: 10 }}>
                          <i>Created at : {moment(item.createdAt).format("lll")}</i>
                        </b>
                        {item.updatedAt && (
                          <b style={{ marginRight: 10 }}>
                            <i> , Updated at : {moment(item.updatedAt).format("lll")}</i>
                          </b>
                        )}
                      </Row>
                    </div>
                  </Col>
                </Panel>
              </Collapse>
            </List.Item>
          )}
        />
      </Col>
    </Fragment>
  );
};

export default SRList;
